import { BodyText, Flex } from '@utilitywarehouse/hearth-react';
import {
  CloseSmallIcon,
  TickSmallIcon,
} from '@utilitywarehouse/hearth-react-icons';
import { FC, ReactNode } from 'react';

import './styles.scss';

interface BreakdownItemProps {
  children: ReactNode;
  type?: 'notCovered' | 'covered';
}

const BreakdownItem: FC<BreakdownItemProps> = ({ children, type }) => (
  <Flex asChild spacing="sm">
    <li>
      {type === 'notCovered' ? <CloseSmallIcon /> : <TickSmallIcon />}
      <BodyText>{children}</BodyText>
    </li>
  </Flex>
);

export { BreakdownItem };
